import { atomWithStorage, createJSONStorage } from 'jotai/utils';

export type LastOpenProject = {
	projectId: string | null;
	revisionId: string | null;
	orgName: string | null;
};

export const lastOpenProjectAtom = atomWithStorage<LastOpenProject>(
	'last-open-project',
	{
		projectId: null,
		revisionId: null,
		orgName: null,
	},
	createJSONStorage(() => sessionStorage),
);
